exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumbs{clear:both;width:100%;overflow:hidden;display:none}ul.breadcrumb-list{list-style:none;margin:0;padding:0;color:#9f9f9f}ul.breadcrumb-list li{float:left;line-height:34px}ul.breadcrumb-list li i{padding:2px 0;display:inline-block}ul.breadcrumb-list li a button{color:#9f9f9f}ul.breadcrumb-list li a:hover button{text-decoration:none}@media (min-width:768px){.breadcrumbs{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/components/Breadcrumbs/Breadcrumbs.scss
// module id = 733
// module chunks = 0